import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import LeaseList from "./LeaseList";
import LeaseForm from "./LeaseForm";

import Dialog from '@material-ui/core/Dialog';
import CustomDialogClose from 'components/CustomDialog/CustomDialogClose';

const Lease = (props) => {
    
    const [tab, setTab] = useState('List');
    const [leaseData, setLeaseData] = useState(null);
    const [msgsForAdd, setMsgsForAdd] = useState({error:null,success:null});
    const [openedAsk, setOpenedAsk] = useState(false);

    const { leasesData, dataObj, getLeases, canEdit, canDelete, contactsData, getContacts,
        createLease, updateLease, deleteLease, error, success,
        propertyAction, setLeasesForAdd, leasesForAdd } = props;

    const cleanAddData = (data) => {
        const newData = { ...data };
        if (typeof newData.other_data === 'string') newData.other_data = JSON.parse(newData.other_data);
        return newData;
    }

    const addForAdd = (data) => {
        setMsgsForAdd({error:null,success:null});
        const newData = { ...data, id:leasesForAdd.length };
        const newList = [ ...leasesForAdd, newData ];
        setLeasesForAdd(newList);
        setMsgsForAdd({error:null,success:'Added Lease'});
    }
    const updateForAdd = (data) => {
        setMsgsForAdd({error:null,success:null});
        const newList = [ ...leasesForAdd ].map((l,i) => {
            if (i === data.id) return data;
            return l;
        })
        setLeasesForAdd(newList);
        setMsgsForAdd({error:null,success:'Updated Lease'});
    }
    const deleteForAdd = (index) => {
        setMsgsForAdd({error:null,success:null});
        const newList = [ ...leasesForAdd ].filter((f,i) => {
            if (i === index) return false;
            return true;
        })
        setLeasesForAdd(newList);
        setMsgsForAdd({error:null,success:'Deleted Lease'});
    }

    useEffect(() => {
        if (dataObj) {
            if (dataObj.id) {
                getLeases(dataObj.id);
            }
        }
    }, [])

    const showForm = (tab === 'View' || tab === 'Add' || tab === 'Edit');


    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                {props.propertyAction !== 'View' && <Button
                    color={tab === 'Add' ? 'success' : 'primary'}
                    onClick={() => {
                        setTab('Add');
                    }}
                >
                    <i className="fa fa-plus"></i> Add Lease
                </Button>}
                <hr />
                {tab === 'List' && <LeaseList
                    canEdit={propertyAction !== 'Add' ? canEdit : true}
                    leasesData={propertyAction !== 'Add' ? leasesData : leasesForAdd}
                    leaseData={leaseData}
                    setLeaseData={setLeaseData}
                    setTab={setTab}
                />}
                {showForm &&
            <Dialog
                open={showForm ? true : false}
                keepMounted
                maxWidth={false}
                fullWidth={true}
                fullScreen={true}
            >
          <div className="dialog-wrapper">
                <LeaseForm
                    leaseData={propertyAction !== 'Add' ? leaseData : cleanAddData(leaseData)}
                    action={tab}
                    setTab={setTab}
                    canEdit={propertyAction !== 'Add' ? canEdit : true}
                    canDelete={propertyAction !== 'Add' ? canDelete : true}
                    getContacts={getContacts}
                    contactsData={contactsData}
                    setMsgsForAdd={setMsgsForAdd}

                    updateLease={propertyAction !== 'Add' ? updateLease : updateForAdd}
                    createLease={propertyAction !== 'Add' ? createLease : addForAdd}
                    deleteLease={propertyAction !== 'Add' ? deleteLease : deleteForAdd}
                    getLeases={() => {
                        if (propertyAction !== 'Add') {
                            getLeases(dataObj.id);
                        }
                    }}
                    propertyID={dataObj.id}
                    error={propertyAction !== 'Add' ? error : msgsForAdd.error}
                    success={propertyAction !== 'Add' ? success : msgsForAdd.success}
                    contactLoading={props.contactLoading}

                    setOpenedAsk={setOpenedAsk}
                    showCloseBtn={true}

                    propertyAction={propertyAction}
                />
            </div>
        </Dialog>
                }
            </GridItem>
            {openedAsk && <CustomDialogClose
                        ok_go={() => {
                            setTab('List');
                        }}
                        open={openedAsk}
                        close={() => {
                            setOpenedAsk(false);
                        }}
                    />}
        </GridContainer>
    )
}

const mapStateToProps = state => {
    const p = state.crm_properties;
    const c = state.crm_contacts;
    return {
        error: p.error,
        success: p.success,
        leasesData: p.leasesData,
        leaseData: p.leaseData,
        loading: p.loading,
        contactsData: c.contactsData,
        contactLoading: c.loading,
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      getLeases: (property_id) => {
          dispatch(actions.getLeases(property_id));
      },
      getLease: (id) => {
          dispatch(actions.getLease(id));
      },
      createLease: (data) => {
          dispatch(actions.createLease(data));
      },
      updateLease: (data) => {
          dispatch(actions.updateLease(data));
      },
      deleteLease: (id) => {
          dispatch(actions.deleteLease(id));
      },
      getContacts: (params) => {
          dispatch(actions.getContacts(params));
      }
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(Lease);
